import {
  Box,
  LinkAnchor,
  List,
  ListItem,
  Notification,
  NotificationProps,
  Typo,
} from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import React, { FunctionComponent } from 'react'

import { TKeyBuilder } from '../../../infrastructure/internationalisation'
import { RejectFiles } from './actions'

export interface RejectionNotificationProps extends NotificationProps {
  t: TFunction
  tKey: TKeyBuilder
  loading: boolean
  rejected: RejectFiles[]
  onDismiss: () => void
}

export const RejectionNotification: FunctionComponent<RejectionNotificationProps> = ({
  t,
  tKey,
  loading,
  rejected,
  onDismiss,
  ...props
}) => {
  return (
    <Notification type='standalone' variant='critical' {...props}>
      <Box mr={2}>
        <Typo mb={1} fontWeight='bold'>
          {t(tKey('rejections'))}
        </Typo>
        <List>
          {rejected.map((it, index) => {
            const message = t([
              tKey('validation', it.error),
              tKey('validation', 'unknown'),
            ])

            return (
              <ListItem variant='bullet' wordBreak='break-word' key={index}>
                {it.name} ({message})
              </ListItem>
            )
          })}
        </List>
      </Box>
      <LinkAnchor
        variant='standalone'
        disabled={loading}
        onClick={onDismiss}
        typoSize='sm'
      >
        {t(tKey('actions', 'dismiss'))}
      </LinkAnchor>
    </Notification>
  )
}
